import cronstrue from "cronstrue";

/**
 * An abstraction that parses a cron expression and outputs a human readable description of the cron schedule
 *
 * @param string The string to be formatted
 * @returns human readable description of the cron schedule
 */
export const cronToSimpleDisplayText = (expression: string): string => {
  const parsedValue = cronstrue.toString(expression, {
    /**
     * AWS thinks of days of the week as 1-7 or SUN-SAT.
     * This means that days of the week start at 1, not zero.
     * https://docs.aws.amazon.com/scheduler/latest/UserGuide/schedule-types.html
     */
    dayOfWeekStartIndexZero: false,
  });

  return `${parsedValue} (UTC)`;
};
